export default __webpack_public_path__ + "static/media/flop-types_0002_thumb.213b28fe.jpg";